var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MediaQuery from 'react-responsive';
import PropsChecker from '@core-front/props-checker';
import { ThemeContext } from '@core-front/theme-provider';
const TabCordionCore = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "TabCordion", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" },
        React.createElement(TabCordionInner, Object.assign({}, props))));
};
export class TabCordionInner extends React.Component {
    constructor(props) {
        super(props);
        this.onTabChange = (prevTab, nextTab) => {
            if (this.currentTab !== nextTab) {
                if (!this.isCurrentTabControlled()) {
                    this.setState({
                        currentTab: nextTab,
                    });
                }
            }
            /* istanbul ignore else */
            if (this.props.onTabChange) {
                this.props.onTabChange(prevTab, nextTab);
            }
        };
        this.onAccordionChange = (nextOpenId) => {
            if (!this.isCurrentTabControlled()) {
                this.setState({
                    currentTab: nextOpenId,
                });
            }
            /* istanbul ignore else */
            if (this.props.onTabChange) {
                this.props.onTabChange(this.currentTab, nextOpenId);
            }
        };
        this.renderAccordionItem = (props) => {
            const { AccordionContent, AccordionHeader, AccordionItem, AccordionTitle } = this.props.components;
            return (React.createElement(AccordionItem, { className: props.className, type: props.type, icon: props.icon, id: props.id },
                React.createElement(AccordionHeader, null,
                    React.createElement(AccordionTitle, { className: "h4" }, props.label)),
                React.createElement(AccordionContent, null, props.children)));
        };
        this.state = {
            currentTab: props.defaultCurrentTab,
            isMounted: false,
        };
    }
    componentDidMount() {
        const { media } = this.context;
        const { breakPoint } = this.props;
        this.setState({
            isMounted: true,
        });
        if (!window.matchMedia(`(min-width: ${media.width[breakPoint].min})`).matches) {
            this.onTabChange(this.currentTab, null);
        }
    }
    get currentTab() {
        return this.isCurrentTabControlled(this.props.currentTab)
            ? this.props.currentTab || this.props.defaultCurrentTab
            : this.state.currentTab || this.props.defaultCurrentTab;
    }
    get currentAccordion() {
        return this.isCurrentTabControlled(this.props.currentTab) ? this.props.currentTab : this.state.currentTab;
    }
    isCurrentTabControlled(currentTab = this.props.currentTab) {
        return !!this.props.onTabChange && typeof currentTab !== 'undefined';
    }
    BEM() {
        const classArray = ['tab-cordion'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    mapChildren(isAccordion = false) {
        const { TabsItem } = this.props.components;
        return React.Children.toArray(this.props.children)
            .filter((child) => {
            return React.isValidElement(child) && child.type === TabsItem;
        })
            .map(child => {
            if (isAccordion) {
                const AccordionItem = this.props.accordionItemRenderer || this.renderAccordionItem;
                const props = Object.assign(Object.assign({}, child.props), { className: 'tab-cordion__item' });
                return React.createElement(AccordionItem, Object.assign({}, props, { key: child.props.id }));
            }
            else {
                return React.cloneElement(child, {
                    icon: !this.props.hideIconsOnTabs ? child.props.icon : undefined,
                });
            }
        });
    }
    renderTabs() {
        const _a = this.props, { currentTab, defaultCurrentTab, onTabChange, breakPoint, hideIconsOnTabs, headingLevel, components: { Tabs }, accordionItemRenderer } = _a, rest = __rest(_a, ["currentTab", "defaultCurrentTab", "onTabChange", "breakPoint", "hideIconsOnTabs", "headingLevel", "components", "accordionItemRenderer"]);
        return (React.createElement(Tabs, Object.assign({}, rest, { currentTab: this.currentTab, onTabChange: this.onTabChange, headingLevel: headingLevel ? headingLevel : 2 }), this.mapChildren()));
    }
    renderAccordion() {
        const { Accordion } = this.props.components;
        return (React.createElement(Accordion, { openItem: this.currentAccordion, onToggle: this.onAccordionChange, className: this.BEM(), bordered: false, headingLevel: this.props.headingLevel ? this.props.headingLevel : 2 }, this.mapChildren(true)));
    }
    renderTabCordion() {
        const { media } = this.context;
        const { breakPoint } = this.props;
        return React.createElement(MediaQuery, { minWidth: media.width[breakPoint].min }, matches => (matches ? this.renderTabs() : this.renderAccordion()));
    }
    render() {
        return this.state.isMounted ? this.renderTabCordion() : this.renderTabs();
    }
}
TabCordionInner.contextType = ThemeContext;
TabCordionInner.defaultProps = {
    breakPoint: 'sm',
};
export default TabCordionCore;
